//DOOR CANVASSES
import { store } from "../../index";
import * as actions from "../../actions";
import api from "../api";

const ERROR_TIMEOUT = 10000;

export const postDoorDataAction = (data) => {
  return api
    .post("/door-data-action/", data)
    .then((res) => res.data)
    .catch((err) => {
      console.warn(err);
      return err;
    });
};

export const getDoorsFilePreview = (filename) => {
  return api
    .get("/doors-file-preview", { filename, preview_length: 10 })
    .catch((error) => {
      console.warn(error);
    });
};

export const getS3SignedUrl = (filename) => {
  return api
    .get("/presigned-media-url", { filename, method: "PUT" })
    .catch((error) => {
      console.warn(error);
    });
};

export const createPass = (data) => {
  store.dispatch(actions.setCampaignDoorCanvassPassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassPassesError(false));

  return api
    .post("doorcanvasspasses/", data)
    .then((response) => {
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPassesError(false));
      return response.data;
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPassesError(true));
    });
};

export const pullCampaignDoorCanvasses = () => {
  store.dispatch(actions.setCampaignDoorCanvassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassesError(false));

  return api
    .get("doorcanvasses/", {})
    .then((res) => {
      store.dispatch(actions.setCampaignDoorCanvassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvasses(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignDoorCanvassesError(true));
      setTimeout(
        () => store.dispatch(actions.setCampaignDoorCanvassesError(false)),
        ERROR_TIMEOUT
      );
    });
};

// DOOR CANVASS PASSES
export const pullCampaignDoorCanvassPasses = (params) => {
  store.dispatch(actions.setCampaignDoorCanvassPassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassPassesError(false));

  return api
    .get("doorcanvasspasses/", params)
    .then((res) => {
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPasses(res.data));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignDoorCanvassPassesError(true));
      setTimeout(
        () => store.dispatch(actions.setCampaignDoorCanvassPassesError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const pullDoorCrews = (params) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .get("doorcrews/", params)
    .then((res) => {
      store.dispatch(actions.setDoorCrewsLoading(false));
      store.dispatch(actions.setDoorCrews(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setDoorCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const createDoorCrew = (data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));
  return api
    .post("doorcrews/", data)
    .then((res) => {
      store.dispatch(actions.insertDoorCrew(res.data));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const createDoorCrewCanvasser = (data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .post(`/doorcrewcanvassers/`, data)
    .then((res) => {
      const seatData = res.data;
      const state = store.getState();
      const crewId =
        typeof seatData.crew === "object" ? seatData.crew?.id : seatData.crew;
      const crew = state.doorCrews.data.find((d) => d.id === crewId);

      if (!crew) {
        console.error("Could not find updated crew in state", crewId, seatData);
        store.dispatch(actions.setDoorCrewsLoading(false));
        return null;
      }

      const updatedCrew = {
        ...crew,
        seats: [
          ...crew.seats,
          { ...seatData, crewcanvasser_id: seatData.id },
        ],
      };

      store.dispatch(actions.removeDoorCrew(crew.id));
      store.dispatch(actions.insertDoorCrew(updatedCrew));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return updatedCrew;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const updateDoorCrewCanvasser = (id, data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .patch(`/doorcrewcanvassers/${id}/`, data)
    .then((res) => {
      let state = store.getState();
      let data = res.data;
      let crew = state.doorCrews.data.find((d) => d.id === data.crew);
      if (!crew) {
        console.error("Could not find updated crew in state");
      }

      store.dispatch(actions.removeDoorCrew(data.crew));
      crew.seats = crew.seats.map((d) => (d.id === data.id ? data : d));

      store.dispatch(actions.insertDoorCrew(crew));
      store.dispatch(actions.setDoorCrewsLoading(false));

      console.log("updated door crew canvasser", crew);
      return crew;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const deleteDoorCrew = (id) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .delete(`/doorcrews/${id}/`)
    .then((res) => {
      store.dispatch(actions.removeDoorCrew(id));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return true;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
      return false;
    });
};

export const deleteDoorCrewCanvasser = (id) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .delete(`/doorcrewcanvassers/${id}/`)
    .then((res) => {
      let state = store.getState();
      let crew = state.doorCrews.data.find(
        (d) => !!d.seats.map((s) => s.id).includes(id)
      );
      if (!crew) {
        console.error("Could not find updated crew in state");
      }

      store.dispatch(actions.removeDoorCrew(crew.id));
      crew.seats = crew.seats.filter((d) => d.id !== id);

      store.dispatch(actions.insertDoorCrew(crew));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return crew || {};
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
      return {};
    });
};

export const getTurfCodes = () => {
  let state = store.getState();
  if (state.turfCodes.data.length) return;

  store.dispatch(actions.setTurfCodesError(false));
  store.dispatch(actions.setTurfCodesLoading(true));

  return api
    .get("/turfcodes/")
    .then((res) => {
      store.dispatch(actions.setTurfCodes(res.data));
    })
    .catch(() => {
      store.dispatch(actions.setTurfCodesError(true));
    })
    .then(() => {
      store.dispatch(actions.setTurfCodesLoading(false));
    });
};

export const createTurfNote = (turf) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .post("/turfnotes/", turf)
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      console.log("CAUGHT A TURFNOTE CREATE ERROR");
      store.dispatch(actions.setSiteNotesError("Note failed to create"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
      throw e;
    });
};

export const removeTurfNote = (turfnote_id) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));
  return api
    .patch(`turfnotes/${turfnote_id}/`, { is_active: false })
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setSiteNotesError("Note failed to delete"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};

export const createDistrictNote = (district) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .post("/districtnotes/", district)
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      console.log("CAUGHT A DISTRICTNOTE CREATE ERROR");
      store.dispatch(actions.setSiteNotesError("Note failed to create"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
      throw e;
    });
};

export const removeDistrictNote = (districtnote_id) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));
  return api
    .patch(`districtnotes/${districtnote_id}/`, { is_active: false })
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setSiteNotesError("Note failed to delete"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};
